// ============================================================================
// EXTENDED GCD - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'extended-gcd',
  name: 'Extended GCD',
  category: 'Math',
  complexity: {
    time: 'O(log min(a, b))',
    space: 'O(log min(a, b))'
  },
  description: 'An extension of the Euclidean algorithm that not only computes the greatest common divisor of two integers but also finds coefficients x and y such that ax + by = gcd(a, b). Essential for modular inverse computation.'
};
